import React from "react";
import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./Gallery.css"; // Make sure your custom CSS is here

const Gallery = () => {
  const { t } = useTranslation();

  const galleryImages = [1, 2, 3, 4, 5, 6, 7, 8];

  return (
    <section id="gallery" className="gallery-section py-5">
      <Container>
        <h2 className="section-title text-center mb-5" data-aos="fade-up">
          {t("gallery.title")}
          <div className="underline"></div>
        </h2>
        <div className="gallery-grid">
          {galleryImages.map((id, idx) => (
            <div
              key={id}
              className="gallery-item"
              data-aos="zoom-in"
              data-aos-delay={idx * 100} // 0ms, 100ms, 200ms delay...
            >
              <img
                src={`/gallery/gallery${id}.jpeg`}
                alt={`Gallery ${id}`}
                className="gallery-img"
              />
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default Gallery;